var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mobile-nav-link",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('div',{staticClass:"visual"},[_vm._t("default"),_c('span',{staticClass:"active-indicator",class:{ 'active' : _vm.active }})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }